/* eslint-disable no-param-reassign */
export const KEYS_CODE = {
  BACKSPACE: 8,
  ENTER: 13,
  SHIFT: 16,
  ARROW_UP: 38,
  ARROW_DOWN: 40,
  DELETE: 46,
  ESCAPE: 27,
  ALT: 18,
  OPTION: 18,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  I: 73,
  K: 75,
  R: 82,
  S: 83,
  U: 85,
  V: 86,
  X: 88,
  Y: 89,
  Z: 90,
};
export const MOUSE_BUTTON = {
  left: 1,
  middle: 2,
  right: 3,
};
